import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-350633d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terms" }
const _hoisted_2 = { class: "terms__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Nutzungsbestimmungen", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Um eine Sprachaufnahme auf RecArena.ch machen zu können, muss den "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.schularena.com/start/nutzungsrichtlinien-ugc",
    target: "_blank"
  }, "Nutzungsbestimmungen (UGC)"),
  /*#__PURE__*/_createTextVNode(" sowie den "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.schularena.com/start/agb",
    target: "_blank"
  }, "AGB"),
  /*#__PURE__*/_createTextVNode(" zugestimmt werden.")
], -1))
const _hoisted_5 = { class: "terms__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)), ["prevent"]))
          }, "Zustimmen")
        ])
      ])
    ])
  ]))
}